import { muted } from "./agentStyles";
import { UsedByBody, type UsedByProps } from "./UsedByBody";

export function UsedByBox(props: UsedByProps) {
  return (
    <div
      aria-busy={props.loading}
      className="flex flex-col gap-1.5 rounded-[10px] border border-slate-200 bg-white px-3 py-2.5 text-slate-900 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-100"
    >
      {props.loading && (
        <span className="sr-only">
          Checking which other stores use this field.
        </span>
      )}
      <UsedByBody {...props} />
      <p
        className={`border-t border-slate-200 pt-2 text-xs dark:border-slate-800 ${muted}`}
      >
        Same field means the seller answers once, for every store.
      </p>
    </div>
  );
}
